module.exports = __webpack_public_path__ + "static/media/video.b3b2b618.webp";